var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"right","margin":"40px"}},[_c('div',{staticClass:"uk-inline"},[_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.url}}),_vm._v(" "),_c('div',{staticClass:"uk-position-bottom-left",attrs:{"uk-parallax":"y: -100,0; viewport: 0;"}},[_c('div',{staticStyle:{"margin-left":"10px"}},[_vm._v("\n        "+_vm._s(_vm.caption)+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bd29ec6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LessonImage.vue
// module id = Hu4q
// module chunks = 1